import { HStack } from '@chakra-ui/react';
import { PageHeading } from '@duke-hq/ui/components/PageHeading';
import { Trans } from '@lingui/react/macro';
import ProviderFilterBar from '../../../components/FilterBar/ProviderFilterBar';
import CourseCatalogueModal from '../../components/CourseCatalogueModal';

export default function Header() {
  return (
    <HStack
      py={3}
      px={4}
      gap="4"
      borderBottom="1px"
      borderColor="border.default"
      w="full"
      top="0"
      position="sticky"
      zIndex="999"
      bg="bg.surface"
    >
      <PageHeading whiteSpace="nowrap">
        <Trans>Enrolments Dashboard</Trans>
      </PageHeading>
      <ProviderFilterBar />
      <CourseCatalogueModal />
    </HStack>
  );
}
